package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets1 {
  internal val _11_melachim_b_24_txt: AssetResource by lazy { init__11_melachim_b_24_txt() }

  internal val _11_melachim_b_25_txt: AssetResource by lazy { init__11_melachim_b_25_txt() }

  internal val _12_yeshaaya_01_txt: AssetResource by lazy { init__12_yeshaaya_01_txt() }

  internal val _12_yeshaaya_02_txt: AssetResource by lazy { init__12_yeshaaya_02_txt() }

  internal val _12_yeshaaya_03_txt: AssetResource by lazy { init__12_yeshaaya_03_txt() }

  internal val _12_yeshaaya_04_txt: AssetResource by lazy { init__12_yeshaaya_04_txt() }

  internal val _12_yeshaaya_05_txt: AssetResource by lazy { init__12_yeshaaya_05_txt() }

  internal val _12_yeshaaya_06_txt: AssetResource by lazy { init__12_yeshaaya_06_txt() }

  internal val _12_yeshaaya_07_txt: AssetResource by lazy { init__12_yeshaaya_07_txt() }

  internal val _12_yeshaaya_08_txt: AssetResource by lazy { init__12_yeshaaya_08_txt() }

  internal val _12_yeshaaya_09_txt: AssetResource by lazy { init__12_yeshaaya_09_txt() }

  internal val _12_yeshaaya_10_txt: AssetResource by lazy { init__12_yeshaaya_10_txt() }

  internal val _12_yeshaaya_11_txt: AssetResource by lazy { init__12_yeshaaya_11_txt() }

  internal val _12_yeshaaya_12_txt: AssetResource by lazy { init__12_yeshaaya_12_txt() }

  internal val _12_yeshaaya_13_txt: AssetResource by lazy { init__12_yeshaaya_13_txt() }

  internal val _12_yeshaaya_14_txt: AssetResource by lazy { init__12_yeshaaya_14_txt() }

  internal val _12_yeshaaya_15_txt: AssetResource by lazy { init__12_yeshaaya_15_txt() }

  internal val _12_yeshaaya_16_txt: AssetResource by lazy { init__12_yeshaaya_16_txt() }

  internal val _12_yeshaaya_17_txt: AssetResource by lazy { init__12_yeshaaya_17_txt() }

  internal val _12_yeshaaya_18_txt: AssetResource by lazy { init__12_yeshaaya_18_txt() }

  internal val _12_yeshaaya_19_txt: AssetResource by lazy { init__12_yeshaaya_19_txt() }

  internal val _12_yeshaaya_20_txt: AssetResource by lazy { init__12_yeshaaya_20_txt() }

  internal val _12_yeshaaya_21_txt: AssetResource by lazy { init__12_yeshaaya_21_txt() }

  internal val _12_yeshaaya_22_txt: AssetResource by lazy { init__12_yeshaaya_22_txt() }

  internal val _12_yeshaaya_23_txt: AssetResource by lazy { init__12_yeshaaya_23_txt() }

  internal val _12_yeshaaya_24_txt: AssetResource by lazy { init__12_yeshaaya_24_txt() }

  internal val _12_yeshaaya_25_txt: AssetResource by lazy { init__12_yeshaaya_25_txt() }

  internal val _12_yeshaaya_26_txt: AssetResource by lazy { init__12_yeshaaya_26_txt() }

  internal val _12_yeshaaya_27_txt: AssetResource by lazy { init__12_yeshaaya_27_txt() }

  internal val _12_yeshaaya_28_txt: AssetResource by lazy { init__12_yeshaaya_28_txt() }

  internal val _12_yeshaaya_29_txt: AssetResource by lazy { init__12_yeshaaya_29_txt() }

  internal val _12_yeshaaya_30_txt: AssetResource by lazy { init__12_yeshaaya_30_txt() }

  internal val _12_yeshaaya_31_txt: AssetResource by lazy { init__12_yeshaaya_31_txt() }

  internal val _12_yeshaaya_32_txt: AssetResource by lazy { init__12_yeshaaya_32_txt() }

  internal val _12_yeshaaya_33_txt: AssetResource by lazy { init__12_yeshaaya_33_txt() }

  internal val _12_yeshaaya_34_txt: AssetResource by lazy { init__12_yeshaaya_34_txt() }

  internal val _12_yeshaaya_35_txt: AssetResource by lazy { init__12_yeshaaya_35_txt() }

  internal val _12_yeshaaya_36_txt: AssetResource by lazy { init__12_yeshaaya_36_txt() }

  internal val _12_yeshaaya_37_txt: AssetResource by lazy { init__12_yeshaaya_37_txt() }

  internal val _12_yeshaaya_38_txt: AssetResource by lazy { init__12_yeshaaya_38_txt() }

  internal val _12_yeshaaya_39_txt: AssetResource by lazy { init__12_yeshaaya_39_txt() }

  internal val _12_yeshaaya_40_txt: AssetResource by lazy { init__12_yeshaaya_40_txt() }

  internal val _12_yeshaaya_41_txt: AssetResource by lazy { init__12_yeshaaya_41_txt() }

  internal val _12_yeshaaya_42_txt: AssetResource by lazy { init__12_yeshaaya_42_txt() }

  internal val _12_yeshaaya_43_txt: AssetResource by lazy { init__12_yeshaaya_43_txt() }

  internal val _12_yeshaaya_44_txt: AssetResource by lazy { init__12_yeshaaya_44_txt() }

  internal val _12_yeshaaya_45_txt: AssetResource by lazy { init__12_yeshaaya_45_txt() }

  internal val _12_yeshaaya_46_txt: AssetResource by lazy { init__12_yeshaaya_46_txt() }

  internal val _12_yeshaaya_47_txt: AssetResource by lazy { init__12_yeshaaya_47_txt() }

  internal val _12_yeshaaya_48_txt: AssetResource by lazy { init__12_yeshaaya_48_txt() }

  internal fun values(): List<AssetResource> = listOf(_11_melachim_b_24_txt, _11_melachim_b_25_txt,
      _12_yeshaaya_01_txt, _12_yeshaaya_02_txt, _12_yeshaaya_03_txt, _12_yeshaaya_04_txt,
      _12_yeshaaya_05_txt, _12_yeshaaya_06_txt, _12_yeshaaya_07_txt, _12_yeshaaya_08_txt,
      _12_yeshaaya_09_txt, _12_yeshaaya_10_txt, _12_yeshaaya_11_txt, _12_yeshaaya_12_txt,
      _12_yeshaaya_13_txt, _12_yeshaaya_14_txt, _12_yeshaaya_15_txt, _12_yeshaaya_16_txt,
      _12_yeshaaya_17_txt, _12_yeshaaya_18_txt, _12_yeshaaya_19_txt, _12_yeshaaya_20_txt,
      _12_yeshaaya_21_txt, _12_yeshaaya_22_txt, _12_yeshaaya_23_txt, _12_yeshaaya_24_txt,
      _12_yeshaaya_25_txt, _12_yeshaaya_26_txt, _12_yeshaaya_27_txt, _12_yeshaaya_28_txt,
      _12_yeshaaya_29_txt, _12_yeshaaya_30_txt, _12_yeshaaya_31_txt, _12_yeshaaya_32_txt,
      _12_yeshaaya_33_txt, _12_yeshaaya_34_txt, _12_yeshaaya_35_txt, _12_yeshaaya_36_txt,
      _12_yeshaaya_37_txt, _12_yeshaaya_38_txt, _12_yeshaaya_39_txt, _12_yeshaaya_40_txt,
      _12_yeshaaya_41_txt, _12_yeshaaya_42_txt, _12_yeshaaya_43_txt, _12_yeshaaya_44_txt,
      _12_yeshaaya_45_txt, _12_yeshaaya_46_txt, _12_yeshaaya_47_txt, _12_yeshaaya_48_txt)
}

private fun init__11_melachim_b_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-24.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-24.txt")

private fun init__11_melachim_b_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_11_melachim_b-25.txt\")") as String, rawPath =
    "allChapters/_11_melachim_b-25.txt")

private fun init__12_yeshaaya_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-01.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-01.txt")

private fun init__12_yeshaaya_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-02.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-02.txt")

private fun init__12_yeshaaya_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-03.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-03.txt")

private fun init__12_yeshaaya_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-04.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-04.txt")

private fun init__12_yeshaaya_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-05.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-05.txt")

private fun init__12_yeshaaya_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-06.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-06.txt")

private fun init__12_yeshaaya_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-07.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-07.txt")

private fun init__12_yeshaaya_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-08.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-08.txt")

private fun init__12_yeshaaya_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-09.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-09.txt")

private fun init__12_yeshaaya_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-10.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-10.txt")

private fun init__12_yeshaaya_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-11.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-11.txt")

private fun init__12_yeshaaya_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-12.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-12.txt")

private fun init__12_yeshaaya_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-13.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-13.txt")

private fun init__12_yeshaaya_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-14.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-14.txt")

private fun init__12_yeshaaya_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-15.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-15.txt")

private fun init__12_yeshaaya_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-16.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-16.txt")

private fun init__12_yeshaaya_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-17.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-17.txt")

private fun init__12_yeshaaya_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-18.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-18.txt")

private fun init__12_yeshaaya_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-19.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-19.txt")

private fun init__12_yeshaaya_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-20.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-20.txt")

private fun init__12_yeshaaya_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-21.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-21.txt")

private fun init__12_yeshaaya_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-22.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-22.txt")

private fun init__12_yeshaaya_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-23.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-23.txt")

private fun init__12_yeshaaya_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-24.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-24.txt")

private fun init__12_yeshaaya_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-25.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-25.txt")

private fun init__12_yeshaaya_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-26.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-26.txt")

private fun init__12_yeshaaya_27_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-27.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-27.txt")

private fun init__12_yeshaaya_28_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-28.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-28.txt")

private fun init__12_yeshaaya_29_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-29.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-29.txt")

private fun init__12_yeshaaya_30_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-30.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-30.txt")

private fun init__12_yeshaaya_31_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-31.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-31.txt")

private fun init__12_yeshaaya_32_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-32.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-32.txt")

private fun init__12_yeshaaya_33_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-33.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-33.txt")

private fun init__12_yeshaaya_34_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-34.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-34.txt")

private fun init__12_yeshaaya_35_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-35.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-35.txt")

private fun init__12_yeshaaya_36_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-36.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-36.txt")

private fun init__12_yeshaaya_37_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-37.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-37.txt")

private fun init__12_yeshaaya_38_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-38.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-38.txt")

private fun init__12_yeshaaya_39_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-39.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-39.txt")

private fun init__12_yeshaaya_40_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-40.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-40.txt")

private fun init__12_yeshaaya_41_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-41.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-41.txt")

private fun init__12_yeshaaya_42_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-42.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-42.txt")

private fun init__12_yeshaaya_43_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-43.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-43.txt")

private fun init__12_yeshaaya_44_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-44.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-44.txt")

private fun init__12_yeshaaya_45_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-45.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-45.txt")

private fun init__12_yeshaaya_46_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-46.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-46.txt")

private fun init__12_yeshaaya_47_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-47.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-47.txt")

private fun init__12_yeshaaya_48_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_12_yeshaaya-48.txt\")") as String, rawPath =
    "allChapters/_12_yeshaaya-48.txt")

public actual val SharedRes.assets.allChapters._11_melachim_b_24_txt: AssetResource
  get() = CommonMainAssets1._11_melachim_b_24_txt

public actual val SharedRes.assets.allChapters._11_melachim_b_25_txt: AssetResource
  get() = CommonMainAssets1._11_melachim_b_25_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_01_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_01_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_02_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_02_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_03_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_03_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_04_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_04_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_05_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_05_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_06_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_06_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_07_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_07_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_08_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_08_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_09_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_09_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_10_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_10_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_11_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_11_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_12_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_12_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_13_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_13_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_14_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_14_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_15_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_15_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_16_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_16_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_17_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_17_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_18_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_18_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_19_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_19_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_20_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_20_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_21_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_21_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_22_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_22_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_23_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_23_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_24_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_24_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_25_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_25_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_26_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_26_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_27_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_27_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_28_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_28_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_29_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_29_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_30_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_30_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_31_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_31_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_32_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_32_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_33_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_33_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_34_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_34_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_35_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_35_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_36_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_36_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_37_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_37_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_38_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_38_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_39_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_39_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_40_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_40_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_41_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_41_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_42_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_42_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_43_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_43_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_44_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_44_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_45_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_45_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_46_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_46_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_47_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_47_txt

public actual val SharedRes.assets.allChapters._12_yeshaaya_48_txt: AssetResource
  get() = CommonMainAssets1._12_yeshaaya_48_txt
